import { CompanyExcelRepository } from "../../repositories/CompanyExcelRepository"
import { UploadCompanyExcelDTO } from "../../../data/dto/UploadCompanyExcel.dto"

interface Props {
	CompanyExcelRepository: CompanyExcelRepository
}

export class UploadCompanyExcelUseCase {
	private _companyExcelRepository: CompanyExcelRepository

	constructor({ CompanyExcelRepository }: Props) {
		this._companyExcelRepository = CompanyExcelRepository
	}

	async exec(data: UploadCompanyExcelDTO): Promise<{ success: boolean; message: string }> {
		return await this._companyExcelRepository.uploadCompanyExcel(data)
	}
}
